<template>
    <div class="inventory">
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="add_inventory" title="Agregar Inventario">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <label for="">Sede: </label>
                <select name="" id="" v-model="sede">
                    <option v-for="(sede, index) in sedes" :value="sede" :key="index">{{ sede }}</option>
                </select>
                <button @click="createInventory">Crear Inventario</button>
            </div>
        </b-modal>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="list_inventory" title="Lista de Inventarios">
            <div class="info-wrapper d-flex flex-column align-items-center">

            </div>
        </b-modal>
        <center>
            <div>
                <button class="create" @click="$refs.add_inventory.show()">Crear Inventario</button>
                <h3>Ingresos de inventario</h3>
                <button class="list" @click="$refs.list_inventory.show()">Ver inventarios</button>
            </div>
            <div class="table">
                <table v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="400">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Fecha</th>
                            <th>producto</th>
                            <th>Cantidad</th>
                            <th>Precio</th>
                            <th>Ingreso por</th>
                            <th>Referencia</th>
                            <th>Detalles</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in inventory" :key="index">
                            <td>{{item.id}}</td>
                            <td>{{item.created_at.split($store.state.constants.SEPARETOR)[0]}}</td>
                            <td class="link" @click="$router.push('/productos/' + item.product + '/profile')">{{item.product}}</td>
                            <td>{{item.cant}}</td>
                            <td>{{priceFormat(item.price)}}</td>
                            <td>{{item.name}}</td>
                            <td>{{item.ref}}</td>
                            <td>{{item.detalles}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </center>
    </div>
</template>

<script>
import API from '@/api'
import Price from '@/utils/ConvertPriceNumber'

export default {
    name: 'inventory',
    data() {
        return {
            inventory: [],
            limit: 20,
            offset: 0,
            busy: false,
            listEnd: false,
            itemFlag: false,
            sede: null,
            name: null,
            sedes: [],
            inventarioList: []
        }
    },
    methods: {
        getInventarios() {
            API.getInventarios()
                .then((res) => {
                    this.inventarioList = res
                })
        },
        createInventory() {
            API.createInventory(this.sede)
                .then((res) => {
                    this.getInventarios()
                })
        },
        getSedes() {
            API.getSedesList()
                .then((res) => {
                    this.sedes = res
                })
        },
        priceFormat: function(item) {
            return Price(item)
        },
        loadMore() {
            this.busy = true
            if (!this.listEnd) {
                setTimeout(() => {
                    if (this.inventory.length < this.offset) {
                        this.listEnd = true
                        return
                    }
                    if (this.itemFlag) {
                        this.getInventory()
                        this.busy = false
                    } else {
                        this.loadMore()
                    }
                }, 1000)
            }
        },
        getInventory() {
            API.getInventory(this.limit, this.offset)
                .then((res) => {
                    res.map(item => { this.inventory.push(item) })
                    this.offset += this.limit
                    this.itemFlag = true
                })
        }
    },
    mounted() {
        this.getInventory()
        this.getSedes()
    }
}
</script>

<style scoped>
    .inventory{
        background-color: #cdcdcd;
        height: 90vh;
    }
    .inventory > center {
        height: 100%;
    }
    .inventory > center > div {
        width: 100%;
        height: 12%;
        background-color: #e0b059;
        position: relative;
        border-bottom-style: outset;
    }
    .inventory > center > div > h3 {
        font-weight: bold;
        margin-bottom: 70px;
        position: absolute;
        top: 50%;
        color: #fff;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .inventory > center > .table {
        margin-top: 20px;
        padding: 50px;
        background-color: #e0b059;
        height: 82%;
        color: #fff;
        overflow-y: auto;
        width: 90%;
        border-radius: 20px;
        border-style: inset;
    }
    .inventory > center > div > table > thead > tr > th {
        width: 10%;
        border-style: outset;
        height: 70px;
        background-color: #e0b059;
    }
    .inventory > center > div > table > tbody > tr > td {
        width: 170px;
        border-style: outset;
        background-color: sandybrown;
    }
    .inventory > center > div > table > tbody > tr > link {
        text-decoration: underline;
    }
    .create {
        position: absolute;
        left: 20px;
        top: 20px;
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
    }
    .list {
        position: absolute;
        right: 20px;
        top: 20px;
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
    }
    select {
        width: 250px;
        height: 40px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Tienda/Inventario.vue